import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaUsers, FaDollarSign, FaChartLine } from 'react-icons/fa';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Adira Logistics</h1>
          <p className="text-xl text-gray-600">Welcome to the logistics management system</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex items-center">
              <FaUsers className="text-3xl text-blue-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Drivers</h3>
                <p className="text-gray-600">Manage driver accounts</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex items-center">
              <FaTruck className="text-3xl text-green-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Jobs</h3>
                <p className="text-gray-600">Create and manage jobs</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex items-center">
              <FaDollarSign className="text-3xl text-yellow-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Earnings</h3>
                <p className="text-gray-600">Track driver earnings</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex items-center">
              <FaChartLine className="text-3xl text-purple-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Analytics</h3>
                <p className="text-gray-600">View performance metrics</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Getting Started</h2>
          <p className="text-gray-600 mb-6">
            This is the main dashboard for the Adira Logistics system. 
            Use the navigation menu to access different sections of the admin panel.
          </p>
          <Link
            to="/admin"
            className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors inline-block"
          >
            Go to Admin Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;